import { isBefore, isAfter } from 'date-fns'
import { IOrderItem } from '../../model/order.store'
import { head, filter, map, cloneDeep, reduce, sumBy, reject } from 'lodash'
import { WOMEN_DAY_GIFT_SKUS_MAP, WomenDaysGiftType } from '../skus.utils'
import { WOMEN_20T10_MENUS, WOMEN_20T10_TIME_FRAME } from './cake-2010'
import { getDeliverĐeadline } from './discount-utils'

// Re-export để giữ backward compatibility
export { WOMEN_20T10_TIME_FRAME } from './cake-2010'

/**
 * Chương trình tặng quà ngày Phụ nữ Việt Nam 20/10
 * Áp dụng: 17/10 - 21/10/2025
 * Quà tặng:
 * - card: Thiệp Women's Day (mẫu ngẫu nhiên)
 * - sparkle: Nến pháo bông tăm
 */

export function checkAndGetValidGiftWomen20t10(
  items: IOrderItem[],
  onlineOrder: any,
  giftType: WomenDaysGiftType
) {
  const deliverDeadline = getDeliverĐeadline(onlineOrder)
  let validGiftingSaleSkus: string[] = []
  let validGiftingSaleProducts: any[] = []
  let giftDesc = ''
  let discountNum = 0

  const giftSku = head(WOMEN_DAY_GIFT_SKUS_MAP[giftType])
  if (giftType === 'card') {
    validGiftingSaleSkus = map(
      reject(
        filter(WOMEN_20T10_MENUS, item => item.giftName === 'card'),
        { concept: 'Set DN' }
      ),
      'sku'
    )
    giftDesc = "Thiệp Women's Day (mẫu ngẫu nhiên)"
    discountNum = sumBy(items, item => {
      if (validGiftingSaleSkus.includes(item.sku)) {
        return item.quantity
      }
      return 0
    })
  }

  if (giftType === 'sparkle') {
    validGiftingSaleProducts = filter(WOMEN_20T10_MENUS, item => item.giftName === 'sparkle')
    validGiftingSaleSkus = map(validGiftingSaleProducts, 'sku')
    giftDesc = 'Nến pháo bông tăm'
    const cloneItems = cloneDeep(items)
    const cumulatedItems = Object.values(
      reduce(
        cloneItems,
        (result, item) => {
          result[item.sku] = result[item.sku] || {
            quantity: 0,
            sku: item.sku,
            desc: item.description
          }
          result[item.sku].quantity += item.quantity
          return result
        },
        {} as { [key: string]: { quantity: number; sku: string; desc: string } }
      )
    )
    const sparkleNeed5Skus = map(filter(WOMEN_20T10_MENUS, { sparkleNeed: 5 }), 'sku')
    const sparkleNeed2Skus = map(filter(WOMEN_20T10_MENUS, { sparkleNeed: 2 }), 'sku')
    const sparkleNeed1Skus = map(filter(WOMEN_20T10_MENUS, { sparkleNeed: 1 }), 'sku')

    discountNum = reduce(
      cumulatedItems,
      (result, item) => {
        if (sparkleNeed5Skus.includes(item.sku)) {
          return result + Math.floor(item.quantity / 5)
        }
        if (sparkleNeed2Skus.includes(item.sku)) {
          return result + Math.floor(item.quantity / 2)
        }
        if (sparkleNeed1Skus.includes(item.sku)) {
          return result + item.quantity
        }
        return result
      },
      0
    )
  }

  return {
    isValid:
      isAfter(deliverDeadline, WOMEN_20T10_TIME_FRAME.start) &&
      isBefore(deliverDeadline, WOMEN_20T10_TIME_FRAME.end) &&
      discountNum >= 1,
    giftNum: discountNum,
    giftText: `${giftSku} ${giftDesc}`,
    giftSku,
    saleProgram: `Tặng ${giftDesc}`
  }
}
